export default function resetScrollEffect ({ element } : {element : HTMLDivElement | null}) {
  if(!!element){
  element.scrollTo({left: 0, top: 0, behavior: "smooth"})
  }
  }
  